import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReportOverviewCard from '../ReportOverviewCard';
import noop from '../../utils/noop';

import { getMonthNameWithPrefix } from '../../utils/dateUtility';
import stripHTML from '../../utils/stripHTML';

import {
  ENTERPRISE_MFA_DESCRIPTION,
  ENTERPRISE_MFA_DESCRIPTION_FOR_APPLIANCE,

  PRO_MFA_DESCRIPTION,
  PRO_MFA_DESCRIPTION_FOR_APPLIANCE,

  MACHINE_TO_MACHINE_DESCRIPTION,
  MACHINE_TO_MACHINE_DESCRIPTION_FOR_APPLIANCE,

  DETAILED_REPORT_TYPES as T
} from '../../utils/resources/reports';
import EnterpriseConnectionsQuotaReportOverviewCard from '../EnterpriseConnectionsQuotaReportOverviewCard';

class QuotaSummaryFeatureConsumption extends Component {
  hasMfaUsersQuota() {
    const { featuresReportData } = this.props;

    return (
      featuresReportData &&
      ((featuresReportData.quota && featuresReportData.quota.mfaUsers) ||
        (featuresReportData.total && featuresReportData.total.mfaUsers))
    );
  }

  hasApiCallsQuota() {
    const { featuresReportData } = this.props;

    return (
      featuresReportData &&
      ((featuresReportData.quota && featuresReportData.quota.apiCalls) ||
        (featuresReportData.total && featuresReportData.total.apiCalls))
    );
  }

  hasMfaDuoQuota() {
    const { featuresReportData } = this.props;

    return (
      featuresReportData &&
      ((featuresReportData.quota && featuresReportData.quota.mfaDuo) ||
        (featuresReportData.total && featuresReportData.total.mfaDuo))
    );
  }

  hasMfaGoogleQuota() {
    const { featuresReportData } = this.props;
    return (
      featuresReportData &&
      ((featuresReportData.quota && featuresReportData.quota.mfaGoogle) ||
        (featuresReportData.total && featuresReportData.total.mfaGoogle))
    );
  }

  shouldRenderSummary() {
    const { shouldRenderSummary } = this.props;

    return (
      shouldRenderSummary &&
      (this.hasMfaUsersQuota() ||
        this.hasApiCallsQuota() ||
        this.hasMfaDuoQuota() ||
        this.hasMfaGoogleQuota())
    );
  }

  renderFeaturesOverview() {
    const { featuresReportData, showReportDetails, contactSales, contactSalesLink, isAppliance } = this.props;

    const { month } = featuresReportData;

    return (
      <div className="report-overview-card-container">
        <ReportOverviewCard
              contactSales={contactSales}
              contactSalesLink={contactSalesLink}
              title="Enterprise MFA"
              subtitle={getMonthNameWithPrefix(month)}
              description={stripHTML(ENTERPRISE_MFA_DESCRIPTION)}
              descriptionForAppliance={stripHTML(ENTERPRISE_MFA_DESCRIPTION_FOR_APPLIANCE)}
              charts={[
                {
                  type: 'quotaAuth0Guardian',
                  quota:
                    featuresReportData &&
                    featuresReportData.quota &&
                    featuresReportData.quota.mfaUsers,
                  currentQuota:
                    featuresReportData &&
                    featuresReportData.total &&
                    featuresReportData.total.mfaUsers,
                  percentage:
                    featuresReportData &&
                    featuresReportData.percentage &&
                    featuresReportData.percentage.mfaUsers
                }
              ]}
              isAppliance={isAppliance}
              handleClick={showReportDetails(T.ENTERPRISE_MFA_FEATURE)}
            />
        <ReportOverviewCard
              contactSales={contactSales}
              contactSalesLink={contactSalesLink}
              title="Pro MFA"
              quantityName="Users"
              subtitle={getMonthNameWithPrefix(month)}
              description={stripHTML(PRO_MFA_DESCRIPTION)}
              descriptionForAppliance={stripHTML(PRO_MFA_DESCRIPTION_FOR_APPLIANCE)}
              charts={[
                {
                  type: 'quotaThirdPartyMfa',
                  currentQuota:
                    featuresReportData &&
                    featuresReportData.total &&
                    featuresReportData.total.mfaDuo +
                      featuresReportData.total.mfaGoogle,
                  isActive:
                    featuresReportData &&
                    featuresReportData.quota &&
                    (featuresReportData.quota.mfaDuo ||
                      featuresReportData.quota.mfaGoogle)
                }
              ]}
              isAppliance={isAppliance}
              handleClick={showReportDetails(T.PRO_MFA_FEATURE)}
            />
            <ReportOverviewCard
              contactSales={contactSales}
              contactSalesLink={contactSalesLink}
              title="Machine to Machine Auth"
              subtitle={getMonthNameWithPrefix(month)}
              description={stripHTML(MACHINE_TO_MACHINE_DESCRIPTION)}
              descriptionForAppliance={stripHTML(MACHINE_TO_MACHINE_DESCRIPTION_FOR_APPLIANCE)}
              charts={[
                {
                  type: 'quotaNonInteractiveApi',
                  quota: featuresReportData &&
                  featuresReportData.quota &&
                  featuresReportData.quota.apiCalls,
                  currentQuota: featuresReportData &&
                  featuresReportData.total &&
                  featuresReportData.total.apiCalls,
                  percentage: featuresReportData &&
                  featuresReportData.percentage &&
                  featuresReportData.percentage.apiCalls
                }
              ]}
              quantityName="Auth Calls"
              isAppliance={isAppliance}
              handleClick={showReportDetails(T.MACHINE_TO_MACHINE_FEATURE)}
            />
            <EnterpriseConnectionsQuotaReportOverviewCard key="enterprise-connections" {...this.props} />
      </div>
    );
  }

  render() {
    const { isAppliance } = this.props;
    return (
      <div>
        {this.shouldRenderSummary()
          ? <div>
              <h2 className="report-overview-card-title">Feature Consumption</h2>
              {isAppliance &&
                <p className="report-overview-card-subtitle">
                  These reports show quota consumption in both Private Instance and
                Cloud tenants.
                </p>}
              {this.renderFeaturesOverview()}
            </div>
          : null}
      </div>
    );
  }
}

QuotaSummaryFeatureConsumption.propTypes = {
  enterpriseConnectionsReportData: PropTypes.object,
  shouldRenderSummary: PropTypes.bool,
  featuresReportData: PropTypes.object,
  showReportDetails: PropTypes.func,
  contactSales: PropTypes.func,
  contactSalesLink: PropTypes.string,
  isAppliance: PropTypes.bool
};

QuotaSummaryFeatureConsumption.defaultProps = {
  showReportDetails: noop
};

export default QuotaSummaryFeatureConsumption;
